module.exports = __webpack_public_path__ + "static/media/content-02-m.7c3da230.png";